import { Component, Input } from "@angular/core";
import { MdbModalRef } from "mdb-angular-ui-kit/modal";
import { AudioRestService } from "src/providers/audio-restservice";
import { FileRestService } from "src/providers/file-restservice";
import { FinalUserRestService } from "src/providers/final-user-restservice";
import { UrlService } from "src/services/url-service";
import { globals } from "src/utils/globals";
import {environment} from "@environments/environment";

@Component({
  selector: "app-audio-modal",
  templateUrl: "./audio-modal.component.html",
  styleUrls: ["./audio-modal.component.scss"],
})
export class AudioModalComponent {

  @Input() audios: any = null;

  actualAudioPath: string = null;
  actualAudio = new Audio;

  actualAudioSubPath: string = null;

  state: AudioState = AudioState.PAUSE;

  stopMark: boolean = false;
  audioDurations: { [key: string]: string } = {};

  constructor(
    public modalRef: MdbModalRef<AudioModalComponent>,
    public globals: globals,
    public _urlService: UrlService,
    public _finalUserRestService: FinalUserRestService,
    public _fileRestService: FileRestService,
    public _audioRestService: AudioRestService
  ) {}

  setAudios(audios: any){
    if (audios.data.length > 0){
      this.audios = audios.data;
      this.audios.forEach(audio => {
        this.calculateAudioDuration(audio);
      });
    }
  }

  downloadMp3(audioid) {
    let player: any = document.getElementById('player_' + audioid);
    player.play();
  }

  getAudioUrl(content: string) {
    return environment.urlBaseBackoffice + '/storage/' + content;
  }

  playAudio(audio: any) {
    if (audio && audio.audio_path) {
      let path = this.getAudioUrl(audio.audio_path);

      if (!this.actualAudio || this.actualAudioPath !== path) {
        let audioPlayer = new Audio(path);
        audioPlayer.play();

        this.actualAudioPath = path;
        this.actualAudioSubPath = audio.content;
        this.actualAudio = audioPlayer;
        this.state = AudioState.PLAY;
      } else {
        if (this.state === AudioState.PAUSE) {
          this.actualAudio.play();
          this.state = AudioState.PLAY;
        } else {
          this.actualAudio.pause();
          this.actualAudioPath = null;
          this.actualAudioSubPath = null;
          this.state = AudioState.PAUSE;
        }
      }
    }
  }

  calculateAudioDuration(audio: any) {
    if (audio && audio.content) {
      let decodedContent = atob(audio.content);

      let byteNumbers = new Array(decodedContent.length);
      for (let i = 0; i < decodedContent.length; i++) {
        byteNumbers[i] = decodedContent.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);

      let blob = new Blob([byteArray], { type: 'audio/mp3' });

      let url = window.URL.createObjectURL(blob);
      let audioPlayer = new Audio(url);

      audioPlayer.addEventListener('loadedmetadata', () => {
        let duration = audioPlayer.duration;
        if (!isNaN(duration)) {
          let minutes = Math.floor(duration / 60);
          let seconds = Math.floor(duration % 60);

          let formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

          this.audioDurations[audio.content] = `${minutes}:${formattedSeconds}`;
        }

        window.URL.revokeObjectURL(url);
      });

      audioPlayer.load();
    }
  }

  downloadAudio(audioPath: string) {
    let contentType = 'audio/mp3';

    let decodedContent = atob(audioPath);

    let byteNumbers = new Array(decodedContent.length);
    for (let i = 0; i < decodedContent.length; i++) {
      byteNumbers[i] = decodedContent.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], { type: contentType });

    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = 'audio.mp3';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  deleteAudio(id: any){
    let index = this.audios.findIndex((audio: any) => audio.id === id);

    if (index !== -1) {
    this.audios.splice(index, 1);
    }

    if (this.audios.length == 0){
      this.audios = null;
    }

    this._audioRestService.deleteAudioById(id).subscribe((result: any) => {
      //console.log(result);
    });
  }

}

export enum AudioState{
  PLAY = "Play",
  PAUSE = "Pause"
}
